<template>
  <div id="container"></div>
</template>

<script setup>
import {onMounted, onUnmounted, ref} from "vue";
import AMapLoader from '@amap/amap-jsapi-loader';

let map = ref(null)

const initAMap = (center = [], mapList = [], zoom = 11) => {
  AMapLoader.load({
    key: "af081f9412b93479a047ff0a0537178e", // 申请好的Web端开发者Key，首次调用 load 时必填
    version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
    plugins: [], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
  }).then((AMap) => {
    map.value = new AMap.Map("container", {
      // 设置地图容器id
      viewMode: "3D", // 是否为3D地图模式
      zoom: zoom, // 初始化地图级别
      center: center, // 初始化地图中心点位置

    });
    if (mapList.length > 0) {
      let makerList = [];
      let marker = null;
      mapList.forEach((item, index) => {
        if (item.lnglats[0]) {
          marker = new AMap.Marker({
            position: new AMap.LngLat(item.lnglats[0], item.lnglats[1]),
            title: item.companyName,
            clickable: true,
          });

          marker.on("click", function (e) {
            markerClick(e, "")
          });
          makerList.push(marker);
        }
      });
      map.value.add(makerList);
    }

    //AMap.plugin("AMap.PlaceSearch", function () {
    //  var placeSearch = new AMap.PlaceSearch({
    //    citylimit: false,  //是否强制限制在设置的城市内搜索
    //    map: map.value, // 展现结果的地图实例
    //    panel: "panel", // 结果列表将在此容器中进行展示。
    //    autoFitView: true, // 是否自动调整地图视野使绘制的Marker点都处于视口的可见范围
    //  });
    //  //关键字查询
    //  placeSearch.search('东方明珠', function (status, result) {
    //    // 查询成功时，result即对应匹配的POI信息
    //    console.log(result,"====result========");
    //  });
    //})

    //  搜索功能

  }).catch((e) => {
    console.log(e);
  });
}

const markerClick = (e, name) => {
  map.value.setZoomAndCenter(15, e.target.getPosition()); // 点击放大

}

//销毁
const destroyFn = () => {
  map.value?.destroy();
}

defineExpose({
  initAMap,
  destroyFn
})

onMounted(() => {
  //initAMap();

});

onUnmounted(() => {
  map.value?.destroy();
});
</script>

<style scoped lang="scss">
#container {
  width: 100%;
  height: 100%;
}
</style>
